import qs from 'qs';
import objectToFormData from 'object-to-formdata';
import http from '../http.js';

const convertToFormdata = function(json_data) {
  let formdata = objectToFormData(json_data, { indices: true });
  // Fix for nested fields like contact_email[0].email
  // If data is an empty array, remove it.
  for (let field_id in json_data) {
    if (Array.isArray(json_data[field_id])) {
      if (json_data[field_id].length == 0) {
        delete json_data[field_id];
      }
    }
  }
  return formdata;
};

const querySerialize = function(query_params) {
  return {
    params: query_params,
    paramsSerializer: function(params) {
      return qs.stringify(params, {
        arrayFormat: 'indices',
        encode: false,
      });
    },
  };
};

export default {
  user: {
    me: function(uid) {
      return http.get(`/me/${uid}`, null);
    },
    edit: function(uuid, params) {
      return http.get(`/user/${uuid}/edit`, querySerialize(params));
    },
    update: function(uuid, payload) {
      payload = Object.assign({}, payload, { _method: 'PUT' }); // @todo method spoofing can be removed
      return http.post(`/user/${uuid}`, convertToFormdata(payload));
    },
    logout: function(uuid) {
      return http.post(`/logout/${uuid}`);
    },
  },

  advert: {
    index: function(params) {
      return http.get(`/v2/property`, querySerialize(params));
    },
    my: function(params) {
      return http.get(`/property/my`, querySerialize(params));
    },
    filter: function(params) {
      return http.get(`/property/filter`, querySerialize(params));
    },
    show: function(uuid, params) {
      return http.get(`/property/${uuid}`, querySerialize(params));
    },
    create: function(params) {
      return http.get(`/property/create`, querySerialize(params));
    },
    edit: function(uuid, params) {
      return http.get(`/property/${uuid}/edit`, querySerialize(params));
    },
    store: function(payload) {
      return http.post(`/property`, convertToFormdata(payload));
    },
    update: function(uuid, payload) {
      return http.put(`/property/${uuid}`, convertToFormdata(payload));
    },
    delete: function(uuid) {
      return http.delete(`/property/${uuid}`);
    },

    addToFavorites: function(uuid, payload) {
      return http.post(`/property/${uuid}/favorite`, convertToFormdata(payload));
    },
    removeFromFavorites: function(uuid, payload) {
      return http.delete(`/property/${uuid}/favorite`, convertToFormdata(payload));
    },
    addToInteresting: function(uuid, payload) {
      return http.post(`/property/${uuid}/in_a_hurry`, convertToFormdata(payload));
    },
    removeFromInteresting: function(uuid, payload) {
      return http.delete(`/property/${uuid}/in_a_hurry`, convertToFormdata(payload));
    },
    listFavorites: function(params) {
      return http.get(`/property/favorites`, querySerialize(params));
    },
    publish: function(uuid) {
      return http.post(`/property/${uuid}/publish`);
    },
    unpublish: function(uuid) {
      return http.post(`/property/${uuid}/unpublish`);
    },
    unavailable: function(uuid) {
      return http.post(`/property/${uuid}/unavailable`);
    },
  },

  preference: {
    my: function(params) {
      return http.get(`/preference/my`, querySerialize(params));
    },
    create: function(params) {
      return http.get(`/preference/create`, querySerialize(params));
    },
    edit: function(uuid, params) {
      return http.get(`/preference/${uuid}/edit`, querySerialize(params));
    },
    store: function(payload) {
      return http.post(`/preference`, convertToFormdata(payload));
    },
    update: function(uuid, payload) {
      return http.put(`/preference/${uuid}`, convertToFormdata(payload));
    },
    delete: function(uuid) {
      return http.delete(`/preference/${uuid}`);
    },
    subscribe: function(uuid) {
      return http.post(`/preference/${uuid}/subscribe`);
    },
    unsubscribe: function(uuid) {
      return http.post(`/preference/${uuid}/unsubscribe`);
    },
  },

  search: {
    my: function(params) {
      return http.get(`/search/my`, querySerialize(params));
    },
    create: function(params) {
      return http.get(`/search/create`, querySerialize(params));
    },
    edit: function(uuid, params) {
      return http.get(`/search/${uuid}/edit`, querySerialize(params));
    },
    store: function(payload) {
      for (var pair of convertToFormdata(payload)) {
        console.log(pair[0] + ', ' + pair[1]);
      }
      return http.post(`/search`, convertToFormdata(payload));
    },
    update: function(uuid, payload) {
      return http.put(`/search/${uuid}`, convertToFormdata(payload));
    },
    delete: function(uuid) {
      return http.delete(`/search/${uuid}`);
    },
    subscribe: function(uuid) {
      return http.post(`/search/${uuid}/subscribe`);
    },
    unsubscribe: function(uuid) {
      return http.post(`/search/${uuid}/unsubscribe`);
    },
  },

  subscriptions: {
    index: function(params, type) {
      return http.get(`/subscriptions/${type}`, querySerialize(params));
    },
  },

  media: {
    store: function(payload, index) {
      let config = { headers: { 'Content-Type': 'multipart/form-data' } };
      return http.post(`/media?idx=${index}`, convertToFormdata(payload), config);
    },
    delete: function(uuid) {
      return http.delete(`/media/${uuid}`);
    },
  },

  message: {
    show: function(params) {
      return http.get(`/message`, querySerialize(params));
    },
    store: function(payload) {
      return http.post(`/message`, convertToFormdata(payload));
    },
    blacklist: function(sender_uuid) {
      return http.post(`/message/blacklist/${sender_uuid}`);
    },
    whitelist: function(sender_uuid) {
      return http.delete(`/message/blacklist/${sender_uuid}`);
    },
  },

  notification: {
    my: function(params) {
      return http.get(`/notification/my`, querySerialize(params));
    },
    read: function(uuid) {
      return http.post(`/notification/${uuid}/read`);
    },
    unread: function(uuid) {
      return http.post(`/notification/${uuid}/unread`);
    },
    delete: function(uuid) {
      return http.delete(`/notification/${uuid}`);
    },
  },

  ticket: {
    create: (params) => {
      return http.get(`/ticket/create`, querySerialize(params));
    },
    store: (payload) => {
      return http.post(`ticket`, convertToFormdata(payload));
    },
  },

  article: {
    show: (alias) => http.get(`/article/${alias}`),
  },

  frontpage: {
    featured: (params) => http.get('/frontpage/featured', querySerialize(params)),
    social: () => http.get('/frontpage/social'),
  },
};
